'use client';

import EventDTO from '../models/event';

interface BackgroundBannerImageProps {
  event: EventDTO;
}

const BackgroundBannerImage: React.FC<BackgroundBannerImageProps> = ({ event }) => (
  <div className="fixed top-0 left-0 w-full h-full z-[-1] p-[-32px]">
    <img
      src={event?.banner_image}
      alt=""
      className={'w-full h-full object-cover blur-3xl  opacity-100 transition-opacity duration-400 ease-in-out'}
    />
  </div>
);

export default BackgroundBannerImage;
